import { SiteLocale } from 'apps/website/types/dato';
import { applyTotal } from './transformers/applyTotal';
import { applyNbEmployee } from './transformers/applyNbEmployee';
import { applyOfferTitle } from './transformers/applyOfferTitle';
import { applySingularPlural } from './transformers/applySingularPlural';
import { ShortcodeContext } from '..';
import { applyPrice } from './transformers/applyPrice';

export const createShortcodePricingPage = (
  text: string,
  locale: SiteLocale,
) => {
  const context: ShortcodeContext = { text, locale };

  return {
    applyTotal({
      total,
      totalDiscount,
    }: {
      total: number;
      totalDiscount?: number | null;
    }) {
      applyTotal({ context, total, totalDiscount });
      return this;
    },

    applyNbEmployee({ nbEmployee }: { nbEmployee: number }) {
      applyNbEmployee({ context, nbEmployee });
      return this;
    },

    applyOfferTitle({ offerTitle }: { offerTitle: string }) {
      applyOfferTitle({ context, offerTitle });
      return this;
    },

    applySingularPlural({ count }: { count: number }) {
      applySingularPlural({ context, count });
      return this;
    },

    applyPrice({ price }: { price: number }) {
      applyPrice({ context, price });
      return this;
    },

    toString() {
      return context.text;
    },
  };
};

// declare global {
//   interface String {
//     shortcode: {
//       pricingPage(
//         locale: SiteLocale,
//       ): ReturnType<typeof createShortcodePricingPage>;
//     };
//   }
// }

// // Initialiser l'objet shortcode
// Object.defineProperty(String.prototype, 'shortcode', {
//   get() {
//     return {
//       pricingPage: (locale: SiteLocale) =>
//         createShortcodePricingPage(this.valueOf(), locale),
//     };
//   },
// });
